import { get as restGet, post as restPost, put as restPut, del as restDel, patch as restPatch } from 'aws-amplify/api';
import { ConsoleLogger } from 'aws-amplify/utils';

const logger = new ConsoleLogger("amplifyApiCompat.ts")

export type RestOptions = {
  headers?: Record<string, string>;
  queryParams?: Record<string, any>;
  body?: any;
};

async function toLegacyResponse<T>(operation: ReturnType<typeof restGet | typeof restPost | typeof restPut | typeof restDel | typeof restPatch>): Promise<T> {
  const { body } = await (await operation).response;
  try {
    const json = await body.json();
    logger.debug("json = ", json)
    return json as T;
  } catch (e) {
    throw e;
  }
}

export const API = {
  get<T = any>(apiName: string, path: string, options?: RestOptions): Promise<T> {
    return toLegacyResponse<T>(restGet({
      apiName: apiName,
      path: path,
      options: options
    }));
  },
  post<T = any>(apiName: string, path: string, options?: RestOptions): Promise<T> {
    return toLegacyResponse<T>(restPost({ apiName, path, options }));
  },
  put<T = any>(apiName: string, path: string, options?: RestOptions): Promise<T> {
    return toLegacyResponse<T>(restPut({ apiName, path, options }));
  },
  del<T = any>(apiName: string, path: string, options?: RestOptions): Promise<T> {
    return toLegacyResponse<T>(restDel({ apiName, path, options }));
  },
  patch<T = any>(apiName: string, path: string, options?: RestOptions): Promise<T> {
    return toLegacyResponse<T>(restPatch({ apiName, path, options }));
  },
};
